import fetch from "auth/FetchInterceptor";

const uploadFileService = {};

uploadFileService.create = function (data) {
	return fetch({
		url: "/v1/rest/upload-file",
		method: "post",
		data: data,
	});
};

export default uploadFileService;
